// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"39bc392d","174":"135a49cb","734":"b4283997","852":"80ab6787"}[chunkId] + ".css";
};